import { boletasTypes, vouchersTypes } from "../actions/types";

const initialState = {
  boletas: [],
  loading: false,
  vouchers: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case boletasTypes.OBTENER_BOLETAS:
      return {
        ...state,
        loading: true,
      };
    case boletasTypes.OBTENER_BOLETAS_EXITO:
      return {
        ...state,
        boletas: action.payload,
        loading: false,
      };
    case vouchersTypes.OBTENER_VOUCHERS:
      return {
        ...state,
        loading: true,
      };
    case vouchersTypes.OBTENER_VOUCHERS_EXITO:
      return {
        ...state,
        vouchers: action.payload,
        loading: false,
      };
    case vouchersTypes.GUARDAR_VOUCHER_EXITO:
      return {
        ...state,
        vouchers: [action.payload, ...state.vouchers],
      };
    case vouchersTypes.ELIMINAR_VOUCHER_EXITO:
      return {
        ...state,
        vouchers: state.vouchers.filter(v => v.id_registro_pago !== action.payload.id_registro_pago),
      };
    default:
      return state;
  }
}